import { createContext, useContext, useState } from "react";

const LayoutAppContext = createContext();


export const LayoutAppProvider = ({ children }) => {
    const [nameUser, setNameUser] = useState(true);
    const [navbar, setNavbar] = useState(true);

    return (
        <LayoutAppContext.Provider
            value={{
                nameUser, setNameUser,
                navbar, setNavbar
            }}
        >
            {children}
        </LayoutAppContext.Provider>
    );
}

export const useLayoutAppContext = () => useContext(LayoutAppContext);